<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Información SSO</span></li>
        <li><span class="link-effect">Bandeja Aprobación Solicitudes</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Bandeja Aprobación Solicitudes</h3>
    </div>


    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="model.idCompania" [disabled]="listaCompanias.length == 1"
                (selectionChange)="companiaChanged()">
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.sedes" multiple>
                <mat-option *ngFor="let sede of listaSedes; index as i;"
                  [value]='sede.idSede'>{{sede.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Empresa:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Empresa</mat-label>
              <input matInput type="text" name="empresa" [(ngModel)]="model.contratista" maxlength="40" />
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Tipo:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.tipos" multiple>
                <mat-option *ngFor="let estado of listaTipos; index as i;"
                  [value]='estado.idParametroDetalle'>{{estado.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-naranja" mat-raised-button mat-raised-button [disabled]="esInvalido()"
              (click)="openDialogAprobacion()"><mat-icon>send</mat-icon> Enviar</a>
            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon>
              Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="table-responsive">

        <table mat-table [dataSource]="listaSolicitudes" class="table table-striped table-vcenter">
          <ng-container matColumnDef="anio">
            <th mat-header-cell *matHeaderCellDef>Año</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.anio}}</td>
          </ng-container>
          <ng-container matColumnDef="mes">
            <th mat-header-cell *matHeaderCellDef>Mes</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.nombreMes}}</td>
          </ng-container>
          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.sede}}</td>
          </ng-container>

          <ng-container matColumnDef="empresa">
            <th mat-header-cell *matHeaderCellDef>Empresa</th>
            <td mat-cell *matCellDef="let element">{{ element.contratista }}</td>
          </ng-container>

          <ng-container matColumnDef="tipo">
            <th mat-header-cell *matHeaderCellDef>Tipo de Solicitud</th>
            <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
          </ng-container>

          <ng-container matColumnDef="fechaCreacion">
            <th mat-header-cell *matHeaderCellDef>Fecha Solicitud</th>
            <td mat-cell *matCellDef="let element">{{ element.fechaCreacion | date:'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="solicitante">
            <th mat-header-cell *matHeaderCellDef>Solicitante</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.solicitante}}</td>
          </ng-container>

          <ng-container matColumnDef="aprobado">
            <th mat-header-cell *matHeaderCellDef>Autorizado
              <mat-slide-toggle [(ngModel)]="checkTodosAprobados" (change)="changeAprobadoAll($event)">
              </mat-slide-toggle>
            </th>
            <td mat-cell *matCellDef="let element" class="centre">
              <mat-slide-toggle [(ngModel)]="element.aprobado" (change)="changeAprobado(element)">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="desaprobado">
            <th mat-header-cell *matHeaderCellDef>No Autorizado
              <mat-slide-toggle [(ngModel)]="checkTodosObservados" class="observado"
                (change)="changeDesaprobadoAll($event)">
              </mat-slide-toggle>

            </th>
            <td mat-cell *matCellDef="let element">
              <mat-slide-toggle [(ngModel)]="element.desaprobado" class="observado"
                (change)="changeDesaprobado(element)">
              </mat-slide-toggle>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>